import React from 'react';
import { Typography, Container } from '@mui/material';

const FarmerPortal = () => {
  return (
    <Container>
      <Typography variant="h4">Farmer Portal</Typography>
      <Typography>Coming soon...</Typography>
    </Container>
  );
};

export default FarmerPortal;